<div class="avatar">
  <span *ngIf="ownerFilter" class="initials" [app-tooltip]="{ message: name, position: ['top'] }">{{ initials }}</span>
  <span *ngIf="remaining">+{{ remaining }}</span>
</div>
